import { type EditInCanvasOpenedFrom } from '~/utils/canvases/getEditInCanvasAnalytics';

/** Asset details surfaces that hand one asset to a canvas. A free prompt or the canvases list is not one of these. */
const VERSION_TARGET_OPENED_FROM: ReadonlySet<EditInCanvasOpenedFrom> = new Set<EditInCanvasOpenedFrom>([
  'asset_modal_export_as',
  'asset_modal_header_menu',
  'asset_modal_quick_tools',
  'asset_modal_versions_menu',
  'asset_modal_video_editor',
]);

export const canvasOpenLinksToVersionTarget = (openedFrom: EditInCanvasOpenedFrom, eligibleClipCount: number) =>
  eligibleClipCount === 1 && VERSION_TARGET_OPENED_FROM.has(openedFrom);
